import React from 'react';
import { Observer } from 'mobx-react';
import { toJS } from 'mobx';
import { List, ListItem } from '@material-ui/core';
import UseJoyride from './UseJoyride';
import voucherMenu from './assets/voucherMenu.png';

const VoucherJoyride = () => {
  const StepOne = () => {
    return (
      <div>
        <img src={voucherMenu} alt="menu screenshot" width="100px" />
        <p>
          To pair money that has been collected with an outstanding and recorded
          balance click on the three dot menu to the top right of a transaction
          detail page and select “map voucher"
        </p>
      </div>
    );
  };
  return (
    <Observer
      render={() => {
        const steps = [
          {
            title: 'Transaction Details',
            target: '.voucherStep1',
            content: <StepOne />,
            disableBeacon: true,
          },
        ];
        return (
          <UseJoyride
            id="voucher"
            passedSteps={steps}
            customProps={{ continuous: true }}
          />
        );
      }}
    />
  );
};

export default VoucherJoyride;
